import { render, staticRenderFns } from "./car-attribute-list.vue?vue&type=template&id=3d663bca&scoped=true&"
import script from "./car-attribute-list.vue?vue&type=script&lang=js&"
export * from "./car-attribute-list.vue?vue&type=script&lang=js&"
import style0 from "./car-attribute-list.vue?vue&type=style&index=0&id=3d663bca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d663bca",
  null
  
)

export default component.exports